export * from './lib/UiAppFooterBase';
export * from './lib/types';
export { footerData } from './lib/data';
